import { MonthOption } from "./monthOption";


const DateService = {
    getMonthList: () : MonthOption[] => 
    {
        const locales = "en";
        const format = "long";

        const year = new Date().getFullYear();
        const monthList = Array.from(Array(12).keys());
        const formatter = new Intl.DateTimeFormat(locales, { month: format });

        return monthList.map((monthIndex: number) => {
            return { 
                name: formatter.format(new Date(year, monthIndex)), 
                number: monthIndex+1 
            } as MonthOption
        });
    },

    dropdownYearList: (numberOfYearsBack :number) : number[] =>
    {
        const year = new Date().getFullYear();
        const yearsReturned = [];

        for(let n=0; n<numberOfYearsBack; ++n)
        {
            yearsReturned.push(year - n);
        }
        
        return yearsReturned;
    },

    getMonthNameByNumber : (monthNumber: number) : string | undefined => {
        return DateService.getMonthList().find(x => x.number === monthNumber)?.name
    },
    getMonthNameByDate : (dte: Date | undefined | null) : string | undefined => {
        if(dte === null || dte === undefined) return "";
        return DateService.getMonthList().find(x => x.number === (new Date(dte).getMonth() + 1))?.name
    },
    getMonthDayYearByDate : (date: Date | undefined | null) : {month: string | undefined, day: number | undefined, year: number | undefined} | undefined => {
        if(date === null || date === undefined) return undefined;

        const month = DateService.getMonthList().find(x => x.number === (new Date(date).getMonth() + 1))?.name;
        const day = new Date(date).getDate();
        const year = new Date(date).getFullYear();

        return {month: month, day: day, year: year};
    },
    getMonthAbbrWithDate(date: Date){
        const newDate = new Date(date);
        if(!(newDate instanceof Date)) return;
        const options = { year: 'numeric', month: 'short', day: '2-digit' } as Intl.DateTimeFormatOptions;
        const formattedDate = newDate.toLocaleDateString('en-US', options);
        return formattedDate;

    },
    getDaysUntilDate(startDate: Date){
        
            const now = new Date();
            now.setHours(0,0,0,0)
            const then = new Date(startDate);
            then.setHours(0,0,0,0)
          
            // Calculate the difference in milliseconds
            const diff = then.getTime() - now.getTime();
            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            return `${days}`;
    },
    dateToApiFriendlyFormat(date: Date){
        const formatter = new Intl.DateTimeFormat('en-US', {
            year: 'numeric', month: '2-digit', day: '2-digit',
            hour: '2-digit', minute: '2-digit', second: '2-digit',
            hour12: false,
          });
        const parts = formatter.formatToParts(date);
        const year = parts.find(p => p.type == "year")?.value;
        const month = parts.find(p => p.type == "month")?.value;
        const day = parts.find(p => p.type == "day")?.value;
        const hour = parts.find(p => p.type == "hour")?.value;
        const minute = parts.find(p => p.type == "minute")?.value;
        const second = parts.find(p => p.type == "second")?.value;

        return `${year}-${month}-${day}T${hour}:${minute}:${second}.000`
    }
}

export default DateService;